module.exports = __webpack_public_path__ + "static/media/Farfetch'd_gaussian2.8cfce4d6.png";